// import React, { useState } from 'react';
// import "./WeighbridgeAutomation.css"
// import { motion } from 'framer-motion';
// import pdf from "../../assets/weighbridge-automation-Growbean.pdf"
// import weighbridge from "../../assets/weighbridge.png"


// const WeighbridgeAutomation = () => {
//   const [showContent, setShowContent] = useState(false);

//   const handleDownload = () => {
//     const link = document.createElement('a');
//     link.href = pdf;
//     link.download = 'Weighbridge_Automation.pdf';
//     link.click();

//   };

//   const handleReadMore = () => {
//     setShowContent(true);
//   };

  


//   return (
//     <div>
//       <div className='download-button-div'>
//         <h1 className='wba-heading'>Weighbridge Automation</h1>
        
//       </div>
//       <hr style={{
//         width : '40vw',
//         margin : 'auto'
//       }}/>  


      
       
// <div className='wba-video-container'>
//         <div className='video-containe'>
//         <motion.div
//         className='videos'
//           initial={{ x: -200, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 1 }}
//         >
//           <h4>English</h4>
//           <iframe src="https://drive.google.com/file/d/1pZzdKcq6PHh2oIfA_ugi7J7d809UEPWq/preview" class="video_frames" width="550"    height="350px"  allow="autoplay"></iframe>


//         </motion.div>
//         <motion.div
//         className='videos'
//           initial={{ x: 200, opacity: 0 }}
//           animate={{ x: 0, opacity: 1 }}
//           transition={{ duration: 1 }}
//         >
//           <h4>Hindi</h4>
//           <iframe src="https://drive.google.com/file/d/1MU8GcJan7lQ-FSSr10RIYHjfMngyoZWy/preview" class="video_frames" width="550"    height="350px"  allow="autoplay"></iframe>
//         </motion.div>
//         </div>
     
//         <div className='sub-container'>
//         <motion.div
//         className='videos'
//           initial={{ y: 200, opacity: 0 }}
//           animate={{ y: 0, opacity: 1 }}
//           transition={{ duration: 1 }}
//         >
//           <h4>Marathi</h4>
//           <iframe src="https://drive.google.com/file/d/1SFYDP_fGvCPiWEOLJRnlv6c0tFl6abRL/preview" class="video_frames" width="550"   height="350px"  allow="autoplay"></iframe>
//         </motion.div>
//       </div>
//       </div>
   
      

// <div className='wba-content'>
//         <motion.p
//           className='wba-para'
//           initial={{ x: -200, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         >
//           Weighbridge automation refers to the integration of advanced technology and systems to automate the process of weighing vehicles, particularly heavy trucks, as they transport goods. The primary aim of weighbridge automation is to improve accuracy, efficiency, and security in the weighing process. Here is a detailed look at the various aspects of weighbridge automation:
//         </motion.p>

//         <motion.h3
//           initial={{ x: -200, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         >
//           How Does It Work?
//         </motion.h3>

//         <div className='image' id="image"
//          initial={{ x: -200, opacity: 0 }}
//          whileInView={{ x: 0, opacity: 1 }}
//          viewport={{ once: true }}
//          transition={{ duration: 1 }}>
//           <img src={weighbridge} alt='weighning mechanism'
//            initial={{ x: -200, opacity: 0 }}
//            whileInView={{ x: 0, opacity: 1 }}
//            viewport={{ once: true }}
//            transition={{ duration: 1 }}/>
//         </div>
//           <div class="video-container">

      
// <iframe width="560" height="315"
// src="https://www.youtube.com/embed/rNj9MSDtQrQ"
// title="YouTube video player"
// frameborder="0"
// allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// allowfullscreen>
// </iframe>
// <iframe width="560" height="315"
// src="https://www.youtube.com/embed/aCF3abs3T5w"
// title="YouTube video player"
// frameborder="0"
// allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
// allowfullscreen>
// </iframe>
//       </div>

//         <motion.div
//           className='wba-content-div'
//           initial={{ x: -200, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         >
//           <h4>1. Authorization :</h4>
//           <p className='wba-paras'>
//             This is a fail-safe method to ensure that only authorized vehicle are
// entering the premises. Only after the data is captured from the RFID
// system.  Checks unauthorized entry of vehicles by using
// buzzer and boom barrier.
// The same vehicle cannot be weighed again until the previous weighment process is complete.
// Facility to take daily ones empty vehicle weight and
// use all days (for internal weighment).

//           </p>
          
//         </motion.div>

//         <motion.div
//           className='wba-content-div'
//           initial={{ x: -200, opacity: 0 }}
//           whileInView={{ x: 0, opacity: 1 }}
//           viewport={{ once: true }}
//           transition={{ duration: 1 }}
//         >
//           <h4>2. Positioning :</h4>
//           <p className='wba-paras'>
//           Non-positioned
// vehicles do not give accurate weighment, leading to incorrect data capture and
// affecting the weighment process. Our unmanned system utilized position
// sensors (Weighbridge Centric System) to ensure that every
// single vehicle weighment is accurate.
//           </p>
          
//         </motion.div>

//         {showContent && (
//           <>
//             <motion.div
//               className='wba-content-div'
//               initial={{ x: -200, opacity: 0 }}
//               whileInView={{ x: 0, opacity: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 1 }}
//             >
//               <h4>3. Surveillance :</h4>
//               <p className='wba-paras'>
//                 CCTV/IP cameras are present to enhance security and
// safety. The system automatically captures various images of
// the Vehicle ,and stores it along with the weighment data. Real time camera view available at security
// cabin for all the weigh bridge. System can generate different kind of MIS reports.

//               </p>
//             </motion.div>

//             <motion.div
//               className='wba-content-div'
//               initial={{ x: -200, opacity: 0 }}
//               whileInView={{ x: 0, opacity: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 1 }}
//             >
//               <h4>4. Integration :</h4>
//               <p className='wba-paras'>
//                 After the gross/tare weights are measured, all the information,
// including the photos of the Vehicle,
// are easily integrated with any type of ERP/SAP Platforms. Application support to multi DataBase (SQL
// SERVER/MS Access/Oracle/IBM DB2)
// Vehicle Positioning System through Sensors.
//               </p>
              
//             </motion.div>

//             <motion.div
//               className='wba-content-div'
//               initial={{ x: -200, opacity: 0 }}
//               whileInView={{ x: 0, opacity: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 1 }}
//             >
//               <h4>5. Cost-Cutting :</h4>
//               <p className='wba-paras'>
//               The Cards are reusable hence the stationary cost is
// eliminated
// Completely man less
// Reduces operation cost significantly.
// Helps to control malpractic. Significantly Reduce Transaction time.

//               </p>
              
//             </motion.div>

//             <motion.div
//               className='wba-content-div'
//               initial={{ x: -200, opacity: 0 }}
//               whileInView={{ x: 0, opacity: 1 }}
//               viewport={{ once: true }}
//               transition={{ duration: 1 }}
//             >
//               <h4>6. Alert :</h4>
//               <p className='wba-paras'>
//               Alerts unauthorized entry of vehicles by using buzzer And
// boom barrie.
// Avoid Proxy Weighment of Vehicle. Traffic Lights to regulate the Process.


//               </p>
              
//             </motion.div>
//           </>
//         )}

//         {!showContent && (
//           <motion.p
//             className="read-more"
//             onClick={handleReadMore}
//             initial={{ x: -200, opacity: 0 }}
//             whileInView={{ x: 0, opacity: 1 }}
//             viewport={{ once: true }}
//             transition={{ duration: 1 }}
//           >
//             Read More...
//           </motion.p>
//         )}
//       </div>


    

     

//   <div className='download-button-div'>
//  <motion.div
//           initial={{ x: 0 }}
//           animate={{ x: [0, -10, 10, -10, 10, 0] }}
//           transition={{ duration: 0.5, ease: "easeInOut" }}
//         >
//           <button onClick={handleDownload} className="download-button">Download PDF</button>
//         </motion.div>
//  </div>
//     </div>
//   );
// }

// export default WeighbridgeAutomation;




import React from "react";
import "./WeighbridgeAutomation.css";
import { motion } from "framer-motion";
import pdf from "../../assets/weighbridge-automation-Growbean.pdf";
import weighbridge from "../../assets/weighbridge1.png";
import {
  FaLock,
  FaMapMarkerAlt,
  FaCamera,
  FaPuzzlePiece,
  FaMoneyBillWave,
  FaBell,
} from "react-icons/fa";

const contentCards = [
  {
    icon: <FaLock size={30} color="#ffffff" />,
    title: "Authorization",
    // text: " This is a fail-safe method to ensure that only authorized vehicle are entering the premises. Only after the data is captured from the RFID system.  Checks unauthorized entry of vehicles by using buzzer and boom barrier.The same vehicle cannot be weighed again until the previous weighment process is complete.Facility to take daily ones empty vehicle weight anduse all days (for internal weighment).",
    text: "Ensures only authorized vehicles enter the weighbridge system using RFID-based identification. Prevents unauthorized access and duplicate weighments, improving security in weighbridge automation systems.",
    color: "#27ae60",
  },
  {
    icon: <FaMapMarkerAlt size={30} color="#ffffff" />,
    title: "Positioning",
    // text: " Non-positioned vehicles do not give accurate weighment, leading to incorrect data capture and affecting the weighment process. Our unmanned system utilized position sensors (Weighbridge Centric System) to ensure that every single vehicle weighment is accurate.",
    text: "Accurate vehicle positioning system ensures correct truck weighing results. Sensors detect vehicle placement to avoid incorrect data in weighbridge software.",
    color: "#2980b9",
  },
  {
    icon: <FaCamera size={30} color="#ffffff" />,
    title: "Surveillance",
    // text: " CCTV/IP cameras are present to enhance security and safety. The system automatically captures various images of the Vehicle ,and stores it along with the weighment data. Real time camera view available at security cabin for all the weigh bridge. System can generate different kind of MIS reports.",
    text: "Integrated CCTV and camera systems capture vehicle images and store them with weighbridge data. Enables real-time monitoring and reporting for truck weighing operations.",
    color: "#8e44ad",
  },
  {
    icon: <FaPuzzlePiece size={30} color="#ffffff" />,
    title: "Integration",
    // text: " After the gross/tare weights are measured, all the information, including the photos of the Vehicle, are easily integrated with any type of ERP/SAP Platforms. Application support to multi DataBase (SQLSERVER/MS Access/Oracle/IBM DB2) Vehicle Positioning System through Sensors.",
    text: "Seamless integration with ERP, SAP, and billing systems allows automatic data transfer. Supports multiple databases and enhances weighbridge management system efficiency.",
    color: "#f39c12",
  },
  {
    icon: <FaMoneyBillWave size={30} color="#ffffff" />,
    title: "Cost-Cutting",
    // text: " The Cards are reusable hence the stationary cost is eliminated, Completely man less Reduces operation cost significantly. Helps to control malpractic. Significantly Reduce Transaction time.",
    text: "Reduces operational costs with unmanned weighbridge automation. Eliminates manual processes, reduces errors, and improves transaction speed.",
    color: "#e67e22",
  },
  {
    icon: <FaBell size={30} color="#ffffff" />,
    title: "Alert",
    // text: " Alerts unauthorized entry of vehicles by using buzzer And boom barrie. Avoid Proxy Weighment of Vehicle. Traffic Lights to regulate the Process.",
    text: "Automated alert system detects unauthorized vehicle entry and prevents proxy weighment. Traffic signals and barriers ensure smooth weighbridge operations.",
    color: "#c0392b",
  },
];

const WeighbridgeAutomation = () => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdf;
    link.download = "Weighbridge_Automation.pdf";
    link.click();
  };

  return (
    <div className="wba-page">
      {/* Header Section */}
      <section className="wba-header">
        <div className="wba-header-text">
          <h1>Weighbridge Automation System & Truck Weighing Software</h1>
          <p>
 Advanced weighbridge automation system designed for accurate truck weighing,
  real-time monitoring, and complete industrial automation. Improve efficiency,
  reduce manual errors, and manage weighbridge operations with smart software.          </p>
          <motion.button
            onClick={handleDownload}
            className="wba-download-btn"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Download Brochure
          </motion.button>
        </div>
        
      </section>
      <div className="wba-header-image">
          {/* <img src={weighbridge} alt="Weighbridge Automation" /> */}
          <img src={weighbridge} alt="Weighbridge Automation System Truck Weighing Software RFID Weighbridge" />
        </div>

      {/* Intro Section */}
      <motion.section
        className="wba-intro"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
      >
        <p>
          {/* Weighbridge automation integrates advanced technology to automate weighing vehicles,
          ensuring accuracy, efficiency, and security in all operations. Reduce manual errors,
          speed up transactions, and integrate data directly with your ERP/SAP system. */}
{/* 
          Weighbridge automation refers to the integration of advanced technology and systems to automate the process of weighing vehicles, particularly heavy trucks, as they transport goods. The primary aim of weighbridge automation is to improve accuracy, efficiency, and security in the weighing process. Here is a detailed look at the various aspects of weighbridge automation: */}



          Weighbridge automation system is an advanced solution that automates the process
of weighing heavy vehicles such as trucks using RFID, sensors, and software integration.
This system improves accuracy, reduces manual intervention, and enables real-time
data tracking.

With weighbridge management software, businesses can monitor vehicle movement,
track weight data, generate reports, and integrate operations with ERP and billing systems.
It is widely used in industries like logistics, mining, construction, and manufacturing.
        </p>
      </motion.section>

      {/* Cards Section */}
      <section className="wba-cards">
        {contentCards.map((card, idx) => (
          <motion.div
            key={idx}
            className="wba-card"
            style={{ borderTop: `5px solid ${card.color}` }}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ type: "spring", stiffness: 120, damping: 12, delay: idx * 0.1 }}
          >
            <div className="card-icon" style={{ backgroundColor: card.color }}>
              {card.icon}
            </div>
            <h4>{card.title}</h4>
            <p>{card.text}</p>
          </motion.div>
        ))}
      </section>
    </div>
  );
};

export default WeighbridgeAutomation;